module.exports = __webpack_public_path__ + "vue-dist/img/face-recognition-failed.d53cb415.png";